import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm, SubmissionError } from 'redux-form';

import { updateOrderLines } from 'redux/modules/ordersLines';

import objectDiff from 'utils/objectDiff';

import ProductClaimViewItem from './ProductClaimViewItem';

function onSubmit(values, dispatch, props) {
  const normalizeValues = (formValues) => {
    const normalizedValues = Object.assign({},
      formValues,
      {
        ...formValues['Driver ID'] === '' && { 'Driver ID': null },
        ...formValues.Status && formValues.Status.length > 0 ? {
        'Workflow Status ID': formValues.Status
          .map(statusItem => statusItem.value),
        } : {},
        ...formValues.Status && formValues.Status.filter(statusItem => statusItem.nextWorkflowStatusID).length > 0 ? {
          'Next Workflow Status ID': formValues.Status
            .map(statusItem => statusItem.nextWorkflowStatusID || statusItem.value)
        } : {},
        ...!formValues['Is Delivered']
          && formValues.Status
          && formValues.Status.filter(statusItem => statusItem.isDelivered).length > 0 ? {
          'Is Delivered': true,
        } : {},
      });

    delete normalizedValues.selected;
    delete normalizedValues['Assigned User Name'];
    delete normalizedValues['Selected Assigned User Name'];
    delete normalizedValues['Driver Name'];
    delete normalizedValues['Selected Driver Name'];
    delete normalizedValues.Status;

    return normalizedValues;
  };

  if (props.pristine) {
    throw new SubmissionError({
      _error: 'Nothing to submit',
    });
  }
  const diffValues = objectDiff(values, props.initialValues);
  
  return new Promise((resolve, reject) => {
    dispatch(updateOrderLines({
      values: Object.keys(diffValues).map((key) => ({
        ID: key.replace('-orderLine', ''),
        ...normalizeValues({
          ...diffValues[key],
          ...diffValues[key].Status ? {
            Status: values[key].Status,
          } : {},
          orderID: props.ID,
        }),
      })),
      resolve,
      reject,
      showNotification: Object.keys(values).length === 1,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

function validateForm(values) {
  const errors = {};
  Object.keys(values).forEach((orderLine) => {
    if (!values[orderLine]['Assigned User ID']
      || values[orderLine]['Assigned User ID'].length === 0) {
      errors[orderLine] = errors[orderLine] || {};
      errors[orderLine]['Assigned User Name'] = 'Please, select user from list';
    }

    if (values[orderLine]['Driver Name']
      && (!values[orderLine]['Driver ID']
      || values[orderLine]['Driver ID'].length === 0)) {
      errors[orderLine] = errors[orderLine] || {};
      errors[orderLine]['Driver Name'] = 'Please, select driver from list';
    }

    if (!values[orderLine].Status
      || values[orderLine].Status.length === 0) {
      errors[orderLine] = errors[orderLine] || {};
      errors[orderLine]['Status Name'] = 'Please, select status from list';
    }
  });

  return errors;
}

const ProductClaimViewForm = ({
  handleSubmit,
  submitting,
  change,
  onTextFieldBlur,
  disabled,
  ...otherProps
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    {otherProps['Order Line'].map(orderLineItem => (
      <ProductClaimViewItem
        key={orderLineItem.ID}
        {...orderLineItem}
        submitting={submitting}
        change={change}
        disabled={disabled}
      />
    ))}
  </form>
);

ProductClaimViewForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onTextFieldBlur: PropTypes.func,
  disabled: PropTypes.bool,
  'Order Line': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
};

ProductClaimViewForm.defaultProps = {
  disabled: false,
  onTextFieldBlur: () => {},
};

export default reduxForm({
  onSubmit,
  validate: validateForm,
  enableReinitialize: true,
})(ProductClaimViewForm);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaimView/ProductClaimViewForm.js